import React from 'react'
import Mask from '../assets/img/facemask.png'
import Soap from '../assets/img/soaphand.png'
import Distance from '../assets/img/distancing.png'


export default function Rules(){
    
    return(
        <section className="pb-0 events section-padding section-bg">
            <div className="container">
                <div className="row" data-aos="zoom-in" data-aos-delay="100">
                    <div className="col-md-12 text-center">
                        <h1 className="section-title">Our Protocol Healty Procedure</h1>
                        <br/>
                    </div>
                </div>
                <div className="row text-center mb-5" data-aos="fade-up" data-aos-delay="100">
                    <div className="col-12 mb-5">
                        <h4 className="section-subtitle text-center">Due to Covid-19, We hope everyone following the standard procedure</h4>
                    </div>
                    <div className="col-md-4 mb-5">
                        <img alt={Mask} className="pulse mb-2" src={Mask} width="200" height="200"/>
                        <h2 className="section-item mt-4 mb-5">Using Face Mask</h2>
                    </div>
                    <div className="col-md-4 mb-5">
                        <img alt={Soap} className="pulse mb-2" src={Soap} width="200" height="200"/>
                        <h2 className="section-item mt-4 mb-5">Wash Your Hand</h2>
                    </div>
                    <div className="col-md-4 mb-5">
                        <img alt={Distance} className="pulse mb-2" src={Distance} width="200" height="200"/>
                        <h2 className="section-item mt-4 mb-5">Keep The Distance</h2>
                    </div>
                </div>
            </div>
        </section>
    )
}